import { Link } from "@tanstack/react-router";
import { Bell, Settings, UserRound } from "lucide-react";
import { WorkspaceSwitcher } from "@/components/site/WorkspaceSwitcher";
import { ShieldsLogo } from "@/components/brand/ShieldsLogo";

export type AppWorkspace = "customer" | "partner" | "owner";

type AppHeaderProps = {
  roleLabel?: string;
  avatarUrl?: string | null;
  workspace?: AppWorkspace;
};

const WORKSPACE = {
  customer: { label: "Customer", home: "/customer" as const, notifications: "/notifications" as const, profile: "/account" as const },
  partner: { label: "Partner", home: "/partner" as const, notifications: "/partner/notifications" as const, profile: "/partner/profile" as const },
  owner: { label: "Command Centre", home: "/owner" as const, notifications: "/owner/notifications" as const, profile: "/owner/settings" as const },
};

export function AppHeader({ roleLabel, avatarUrl, workspace = "customer" }: AppHeaderProps) {
  const config = WORKSPACE[workspace];
  return (
    <header className="app-header sticky top-0 z-30 border-b border-border/70 bg-card/95 backdrop-blur-xl">
      <div className="mx-auto flex min-h-16 max-w-5xl items-center gap-3 px-4 sm:px-6">
        <Link to={config.home} className="app-brand-lockup flex shrink-0 items-center gap-2" aria-label={"Shields " + config.label + " home"}>
          <ShieldsLogo tone={workspace === "owner" ? "dark" : "light"} />
          <span className="app-brand-subtitle">{workspace === "partner" ? "Partner" : workspace === "customer" ? "Home" : "Command Centre"}</span>
        </Link>
        <WorkspaceSwitcher fallbackLabel={roleLabel ?? config.label} />
        <div className="ml-auto flex items-center gap-1">
          {workspace !== "owner" && (
            workspace === "customer"
              ? <Link to="/customer/more" aria-label="Customer settings and more" className="header-icon-button"><Settings className="h-5 w-5" aria-hidden /></Link>
              : <Link to="/partner/settings" aria-label="Partner settings" className="header-icon-button"><Settings className="h-5 w-5" aria-hidden /></Link>
          )}
          <Link to={config.notifications} aria-label={config.label + " notifications"} className="header-icon-button">
            <Bell className="h-5 w-5" aria-hidden />
          </Link>
          <Link to={config.profile} aria-label={config.label + " profile"} className="header-avatar">
            {avatarUrl ? <img src={avatarUrl} alt="" className="h-full w-full object-cover" /> : <UserRound className="h-5 w-5" aria-hidden />}
          </Link>
        </div>
      </div>
    </header>
  );
}
